// ============================================================================
// CASE ADVOCATE ENDPOINTS — Phase 9b-2
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const CASE_ADVOCATE_BASE_PATH = '/CaseAdvocate';

export const caseAdvocateEndpoints = {
  byCase: (caseId: ID) =>
    buildEndpointWithParams(`${CASE_ADVOCATE_BASE_PATH}/by-case/:caseId`, { caseId }),
  getById: (id: ID) =>
    buildEndpointWithParams(`${CASE_ADVOCATE_BASE_PATH}/:id`, { id }),
  create: () => buildEndpoint(CASE_ADVOCATE_BASE_PATH),
  update: (id: ID) =>
    buildEndpointWithParams(`${CASE_ADVOCATE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) =>
    buildEndpointWithParams(`${CASE_ADVOCATE_BASE_PATH}/:id`, { id }),
} as const;

export default caseAdvocateEndpoints;
